/* =====================================================
   Dwell & Company — Mobile dwell-to-swap product image
   On mobile, when the shopper stops scrolling and a product
   card is the most prominent one in view, after a short dwell
   the card cross-fades from its first image to its second image
   (mirrors the desktop hover swap). Reverts on scroll or when a
   different card becomes prominent. Only the second image — no
   cycling. Respects prefers-reduced-motion. Pairs with the CSS
   block in assets/custom.css.
   ===================================================== */
(function () {
  'use strict';

  // --- Tunable knobs ------------------------------------------------
  var DWELL_MS = 1200;       // linger time before the swap fires
  var SCROLL_IDLE_MS = 150;  // how long after scrolling stops we consider them "still"
  var EVAL_DEBOUNCE_MS = 80;  // debounce for visibility-driven re-evaluation
  var VISIBLE_RATIO = 0.4;   // a card must be at least this visible to be eligible
  var MOBILE_MQ = '(max-width: 989px)'; // matches the theme's mobile breakpoint
  // -----------------------------------------------------------------

  var reduceMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMQ = window.matchMedia(MOBILE_MQ);

  var observer = null;
  var ratios = new WeakMap();
  var current = null;     // currently swapped card
  var dwellTimer = null;
  var idleTimer = null;
  var evalTimer = null;
  var scrolling = false;
  var started = false;

  function isEligibleCard(card) {
    return !!card.querySelector('.media--hover-effect img.media--second');
  }

  function clearDwell() {
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
  }

  function revert() {
    if (current) { current.classList.remove('dw-mobile-swap'); current = null; }
  }

  function viewportCenter() {
    return (window.innerHeight || document.documentElement.clientHeight) / 2;
  }

  // The single most prominent eligible card: sufficiently visible, whose
  // center is closest to the viewport center. Ties -> first in DOM order
  // (so a grid resolves to the first card in the centered row).
  function mostProminent() {
    var vc = viewportCenter();
    var best = null;
    var bestDist = Infinity;
    document.querySelectorAll('.card-wrapper.dw-mobile-swap-init').forEach(function (card) {
      var ratio = ratios.get(card) || 0;
      if (ratio < VISIBLE_RATIO) return;
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.top + rect.height / 2;
      var dist = Math.abs(cardCenter - vc);
      if (dist < bestDist - 1) { bestDist = dist; best = card; }
    });
    return best;
  }

  function evaluate() {
    if (reduceMotionMQ.matches || !mobileMQ.matches) { clearDwell(); revert(); return; }
    var target = mostProminent();
    if (!target) { clearDwell(); revert(); return; }
    if (target === current) return;
    clearDwell();
    revert();
    dwellTimer = setTimeout(function () {
      if (!scrolling && mobileMQ.matches && !reduceMotionMQ.matches && mostProminent() === target) {
        current = target;
        target.classList.add('dw-mobile-swap');
      }
    }, DWELL_MS);
  }

  function scheduleEvaluate() {
    if (evalTimer) clearTimeout(evalTimer);
    evalTimer = setTimeout(evaluate, EVAL_DEBOUNCE_MS);
  }

  function onScroll() {
    scrolling = true;
    clearDwell();
    revert();
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { scrolling = false; evaluate(); }, SCROLL_IDLE_MS);
  }

  function buildObserver() {
    if (observer) observer.disconnect();
    var thresholds = [];
    for (var i = 0; i <= 10; i++) thresholds.push(i / 10);
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
      if (!scrolling) scheduleEvaluate();
    }, { threshold: thresholds });
  }

  function start() {
    if (started || reduceMotionMQ.matches || !mobileMQ.matches) return;
    var any = false;
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (isEligibleCard(card)) {
        card.classList.add('dw-mobile-swap-init');
        observer.observe(card);
        any = true;
      }
    });
    if (!any) return;
    started = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    idleTimer = setTimeout(evaluate, SCROLL_IDLE_MS);
  }

  function stop() {
    started = false;
    clearDwell();
    if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
    if (evalTimer) { clearTimeout(evalTimer); evalTimer = null; }
    revert();
    window.removeEventListener('scroll', onScroll);
    if (observer) observer.disconnect();
    document.querySelectorAll('.card-wrapper.dw-mobile-swap-init').forEach(function (card) {
      card.classList.remove('dw-mobile-swap-init');
    });
  }

  function init() {
    if (!('IntersectionObserver' in window)) return; // graceful no-op on old browsers
    buildObserver();
    start();
  }

  function bindMQ(mq, handler) {
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }
  bindMQ(reduceMotionMQ, function () {
    if (reduceMotionMQ.matches) { stop(); } else { buildObserver(); start(); }
  });
  bindMQ(mobileMQ, function () {
    if (mobileMQ.matches) { buildObserver(); start(); } else { stop(); }
  });

  document.addEventListener('shopify:section:load', function () { stop(); buildObserver(); start(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
